import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function FransizTentePage() {
  useEffect(() => {
    document.title = 'İzmir Fransız Tente Tamiri | Profesyonel Tamir Servisi';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'İzmir\'de fransız tente tamiri, bakımı ve yenileme hizmetleri. Uzman ekibimizle fransız tenteleriniz için profesyonel çözümler sunuyoruz.');
    }
  }, []);

  const otherServices = [
    { title: 'Karpuz Tente', link: '/hizmetler/karpuz-tente' },
    { title: 'Fermuarlı Şeffaf Tente', link: '/hizmetler/fermuar-seffaf-tente' },
    { title: 'Mafsallı Tente Tamiri', link: '/hizmetler/mafsalli-tente-tamiri' },
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      {/* Hero Image Section */}
      <div className="w-full h-64 md:h-96 overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/1ae69ff768c2530a9442cdb998ebd0fe.jpg"
          alt="Fransız Tente"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="pt-12 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Fransız Tente Tamiri</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                İzmir Fransız Tente Tamiri
              </h1>

              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Fransız tenteler, klasik ve zarif tasarımlarıyla işletmelere ve konutlara estetik bir görünüm kazandıran tente çeşitleridir. İzmir'de fransız tente tamiri, bakımı ve yenileme hizmetleri konusunda uzman ekibimizle yanınızdayız.
              </p>

              {/* Features */}
              <div className="bg-teal-50 rounded-xl p-6 mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Fransız Tente Özellikleri</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">Kavisli Tasarım</h3>
                      <p className="text-xs text-gray-600">Zarif ve estetik görünüm</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">Dekoratif Görünüm</h3>
                      <p className="text-xs text-gray-600">İşletmelere prestij katar</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">Dayanıklı İskelet</h3>
                      <p className="text-xs text-gray-600">Metal veya ahşap konstrüksiyon</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg"></i>
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">Çeşitli Kumaş Seçenekleri</h3>
                      <p className="text-xs text-gray-600">Renk ve desen çeşitliliği</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Services */}
              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Tamir Hizmetlerimiz</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white border border-gray-200 rounded-lg p-5">
                    <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg mb-3">
                      <i className="ri-paint-brush-fill text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="font-semibold text-gray-900 text-sm mb-2">Branda Değişimi</h3>
                    <p className="text-xs text-gray-600">Yıpranan veya solmuş brandanızı yeniliyoruz</p>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg p-5">
                    <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg mb-3">
                      <i className="ri-hammer-fill text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="font-semibold text-gray-900 text-sm mb-2">İskelet Tamiri</h3>
                    <p className="text-xs text-gray-600">Metal veya ahşap iskelet onarımı ve güçlendirme</p>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg p-5">
                    <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg mb-3">
                      <i className="ri-palette-fill text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="font-semibold text-gray-900 text-sm mb-2">Renk ve Desen Yenileme</h3>
                    <p className="text-xs text-gray-600">İşletmenize uygun yeni tasarım seçenekleri</p>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg p-5">
                    <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg mb-3">
                      <i className="ri-tools-fill text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="font-semibold text-gray-900 text-sm mb-2">Montaj ve Kurulum</h3>
                    <p className="text-xs text-gray-600">Yeni fransız tente montajı ve kurulumu</p>
                  </div>
                </div>
              </div>

              {/* Process */}
              <div className="bg-gray-50 rounded-xl p-6 mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Tamir Süreci</h2>
                <div className="space-y-4">
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                      1
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">İletişim ve Randevu</h3>
                      <p className="text-xs text-gray-600">Bizi arayın veya WhatsApp'tan yazın, uygun randevu saati belirleyelim</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                      2
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">Yerinde Keşif</h3>
                      <p className="text-xs text-gray-600">Uzman ekibimiz fransız tentenizi inceler ve arızayı tespit eder</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                      3
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">Fiyat Teklifi</h3>
                      <p className="text-xs text-gray-600">Yapılacak işlemler ve maliyetler hakkında detaylı bilgi veriyoruz</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                      4
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">Profesyonel Tamir</h3>
                      <p className="text-xs text-gray-600">Onayınızın ardından tamir işlemlerini gerçekleştiriyoruz</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="flex-shrink-0 w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                      5
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900 text-sm mb-1">Test ve Teslim</h3>
                      <p className="text-xs text-gray-600">Kalite kontrolü yapılır ve garanti belgesi ile teslim edilir</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Why Choose Us */}
              <div className="mb-8">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Neden Bizi Tercih Etmelisiniz?</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="text-center p-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3">
                      <i className="ri-user-star-fill text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="font-semibold text-gray-900 text-sm mb-2">Uzman Ekip</h3>
                    <p className="text-xs text-gray-600">Alanında deneyimli ve sertifikalı teknisyenler</p>
                  </div>
                  <div className="text-center p-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3">
                      <i className="ri-shield-check-fill text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="font-semibold text-gray-900 text-sm mb-2">Garanti</h3>
                    <p className="text-xs text-gray-600">Tüm işlemlerimizde garanti güvencesi</p>
                  </div>
                  <div className="text-center p-4">
                    <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-3">
                      <i className="ri-time-fill text-teal-600 text-xl"></i>
                    </div>
                    <h3 className="font-semibold text-gray-900 text-sm mb-2">Hızlı Servis</h3>
                    <p className="text-xs text-gray-600">Aynı gün randevu ve hızlı çözüm</p>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-xl p-8 text-center text-white">
                <h2 className="text-2xl font-bold mb-3">Fransız Tenteniz İçin Hemen Arayın</h2>
                <p className="text-sm mb-6 opacity-90">
                  Profesyonel tamir ve bakım hizmetleri için bizimle iletişime geçin
                </p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <a
                    href="tel:+905513723512"
                    className="px-6 py-2.5 bg-white text-teal-600 text-sm font-semibold rounded-lg hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-phone-fill mr-2"></i>
                    Hemen Ara
                  </a>
                  <a
                    href="https://wa.me/905513723512?text=Merhaba,%20izmirtentetamir.net%20web%20siteniz%20üzerinden%20yazıyorum."
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-2.5 bg-teal-800 text-white text-sm font-semibold rounded-lg hover:bg-teal-900 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-fill mr-2"></i>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}